(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[820],{

/***/ 9530:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_error",
      function () {
        return __webpack_require__(584);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3842);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5230);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4246);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(377);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1709);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1924);





var MyError = function(param) {
    var statusCode = param.statusCode, hasGetInitialPropsRun = param.hasGetInitialPropsRun, err = param.err;
    if (!hasGetInitialPropsRun && err) {
        // getInitialProps is not called in case of
        // https://github.com/vercel/next.js/issues/8592. As a workaround, we pass
        // err via _app.js so it can be captured
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_3__/* .captureException */ .Tb(err);
    // Flushing is not required in this case as it only happens on the client
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
        statusCode: statusCode
    });
};
MyError.getInitialProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(context) {
        var errorInitialProps, res, err, asPath;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return next_error__WEBPACK_IMPORTED_MODULE_2__["default"].getInitialProps(context);
                case 2:
                    errorInitialProps = _ctx.sent;
                    res = context.res, err = context.err, asPath = context.asPath;
                    // Workaround for https://github.com/vercel/next.js/issues/8592, mark when
                    // getInitialProps has run
                    errorInitialProps.hasGetInitialPropsRun = true;
                    if (!((res === null || res === void 0 ? void 0 : res.statusCode) === 404)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", errorInitialProps);
                case 7:
                    if (!err) {
                        _ctx.next = 12;
                        break;
                    }
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_3__/* .captureException */ .Tb(err);
                    _ctx.next = 11;
                    return _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .flush */ .yl(2000);
                case 11:
                    return _ctx.abrupt("return", errorInitialProps);
                case 12:
                    // If this point is reached, getInitialProps was called without any
                    // information about what the error might be. This is unexpected and may
                    // indicate a bug introduced in Next.js, so record it in Sentry
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_3__/* .captureException */ .Tb(new Error("_error.js getInitialProps missing data at path: ".concat(asPath)));
                    _ctx.next = 15;
                    return _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .flush */ .yl(2000);
                case 15:
                    return _ctx.abrupt("return", errorInitialProps);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(context) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (MyError);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [494,774,888,179], function() { return __webpack_exec__(9530); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);